import { apiClient } from './apiClient';

class AuthAPI {
  logIn(user) {
    return apiClient.request(
      `/${user.role}s/auth/sign_in`,
      'POST',
      false,
      user
    );
  }

  forgotPassword(user) {
    return apiClient.request(
      `/${user.role}s/auth/password`,
      'POST',
      false,
      user
    );
  }

  resetPassword(user) {
    return apiClient.request(`/${user.role}s/auth/password`, 'PUT', true, user);
  }

  logOut(role = 'admin') {
    return apiClient.request(`/${role}s/auth/sign_out`, 'DELETE', true);
  }

  registerLogoutCallback(callback) {
    return apiClient.registerShutdownCallback(callback);
  }
}
export const authAPI = new AuthAPI();



// WEBPACK FOOTER //
// ./src/InterfaceAPI/authAPI.js